import { defineStore } from 'pinia';
import { must } from '../api/client';
import type { Me } from '../api/types';
import { useContext } from '../context';

export const useSession = defineStore('session', {
  state: () => ({ me: undefined as Me | undefined }),
  getters: {
    customers: (s): string[] => (s.me?.entitlements ?? []).map((e) => e.customer).sort(),
    displayName: (s): string => s.me?.name ?? s.me?.username ?? s.me?.email ?? s.me?.subject ?? '',
  },
  actions: {
    async load() {
      this.me = must(await useContext().api.GET('/me'));
    },
    /** The source environments of the customer whose data the caller may see and order. */
    environments(customer: string): string[] {
      return [...(this.me?.entitlements.find((e) => e.customer === customer)?.environments ?? [])].sort();
    },
  },
});
